module.exports = {
  path: "about",
  childRoutes: [
    require("./OurVineyard"),
    require("./WhoWeAre"),
    require("./VineyardProfile"),
    require("./Wineries")
  ]
};



// WEBPACK FOOTER //
// ./src/routes/About/index.js